module.exports = "/assets/8ba9bd2b5e5e7cef23d323c1345e2aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JP.png
// module id = 1518
// module chunks = 0